import { FC, ReactNode } from 'react';
import { Link } from 'react-router-dom';

import { Box, Flex, rem, StyleProps } from '@bonusly/design-system';

import { useIsRecognize } from '../../../../hooks/use-is-recognize';
import { AppPath } from '../../config/router';
import { NAVBAR_HEIGHT_IN_PX } from './config';

interface NavbarShellProps extends StyleProps {
	children?: ReactNode;
	logo: ReactNode;
}

export const NavbarShell: FC<NavbarShellProps> = ({ children, logo, ...props }) => {
	const isRecognize = useIsRecognize();

	return (
		<Flex alignItems="center" as="nav" h={rem(NAVBAR_HEIGHT_IN_PX)} id="primary-nav" px={{ base: 4, lg: 6 }} w="full" bg="bg.topNav" {...props}>
			<Flex w="full" alignItems="center">
				<Flex alignItems="center" flexBasis={0} flexGrow={1} h={rem(46)}>
					<Box as={Link} id="primary-nav-logo" h="full" maxW={72} reloadDocument={isRecognize} to={AppPath.Home}>
						{logo}
					</Box>
				</Flex>

				{children}
			</Flex>
		</Flex>
	);
};
